import React from "react";
import {FilterItem, FilterItemProps, InputEditor, SelectEditor} from "../tablefilter/TableFilter";
import {SearchFilter} from "../tablefilter/SearchFilter";
import {FindingSeverity} from "../../domain/FindingSeverity";
import {Checkbox} from "antd";

export function createDefaultSbomProjectVersionVulnerableComponentFilterValues() {
    return {severity: [], name: "", onlyDirect: false, hideNotAffected: true, hideAnalysed: false};
}

function SeverityItem(props: FilterItemProps) {
    return (
        <SelectEditor
            options={Object.keys(FindingSeverity).map(severity => ({
                value: severity,
                label: <span style={{display: "inline-block"}} className={"selection-item-text"}>&gt;= {severity}</span>
            }))}
            multiple={false}
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    );
}

function NameItem(props: FilterItemProps) {
    return (
        <InputEditor
            value={props.value}
            onChange={value => props.onChange(value)}
        />
    );
}

function CheckboxItem(props: FilterItemProps) {
    return (
        <Checkbox checked={props.value} onChange={value => props.onChange(value.target.checked)} />
    );
}

interface FilterProps {
    className?: string;
    values?: any;
    onChange: (values: any) => void;
    immediateMode?: boolean;
    persistentStateIdent?: string;
}

type CheckboxFilterName = "onlyDirect" | "hideNotAffected" | "hideAnalysed";

function SbomProjectVersionVulnerableComponentFilter(filterProps: FilterProps) {
    function toggleFilterValue(name: CheckboxFilterName) {
        filterProps.onChange({
            ...filterProps.values,
            [name]: !filterProps.values[name]
        });
    }

    const items: FilterItem[] = [
        {
            name: "name",
            key: "name",
            label: "Name",
            render: (props) => <NameItem {...props} />
        },
        {
            name: "severity",
            key: "severity",
            label: "Finding severity",
            render: (props) => <SeverityItem {...props} />
        },
        {
            name: "onlyDirect",
            key: "onlyDirect",
            label: "Only direct dependencies",
            labelCursor: "pointer",
            onLabelClick: () => toggleFilterValue("onlyDirect"),
            render: (props) => <CheckboxItem {...props} />
        },
        {
            name: "hideNotAffected",
            key: "hideNotAffected",
            label: "Hide not affected",
            labelCursor: "pointer",
            onLabelClick: () => toggleFilterValue("hideNotAffected"),
            render: (props) => <CheckboxItem {...props} />
        },
        {
            name: "hideAnalysed",
            key: "hideAnalysed",
            label: "Hide analysed",
            labelCursor: "pointer",
            onLabelClick: () => toggleFilterValue("hideAnalysed"),
            render: (props) => <CheckboxItem {...props} />
        },
    ];

    return (
        <SearchFilter
            items={items}
            className={filterProps.className}
            values={filterProps.values}
            defaultValues={createDefaultSbomProjectVersionVulnerableComponentFilterValues()}
            persistentStateIdent={filterProps.persistentStateIdent}
            defaultActiveFilterNames={["name", "severity", "onlyDirect", "hideAnalysed", "hideNotAffected"]}
            immediateMode={filterProps.immediateMode}
            onChange={filterProps.onChange}
        />
    );
}

export default SbomProjectVersionVulnerableComponentFilter;
